'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
var debounce = require('./debounce.js');
function throttle(func, throttleMs) {
    var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, signal = _ref.signal, _ref_edges = _ref.edges, edges = _ref_edges === void 0 ? [
        'leading',
        'trailing'
    ] : _ref_edges;
    var pendingAt = null;
    var debounced = debounce.debounce(func, throttleMs, {
        signal: signal,
        edges: edges
    });
    var throttled = function throttled() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        if (pendingAt == null) {
            pendingAt = Date.now();
        } else {
            if (Date.now() - pendingAt >= throttleMs) {
                pendingAt = Date.now();
                debounced.cancel();
            }
        }
        debounced.apply(this, args);
    };
    throttled.cancel = debounced.cancel;
    throttled.flush = debounced.flush;
    return throttled;
}
exports.throttle = throttle;
